'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/react/react.js
// module id = 3
// module chunks = 0